import {allRequest, postRequest, REQUEST_METHOD_POST} from '../../../../../middlewares/api/actions';
import {getUploadFileOnServerUrl} from '../../../../../constants/urls';

export const FILE_MAPPING_WIZARD_CSV_FORM_CHANGE = 'FILE_MAPPING_WIZARD_CSV_FORM_CHANGE';
export const FILE_MAPPING_WIZARD_CSV_FORM_FILE_FORMAT_SET = 'FILE_MAPPING_WIZARD_CSV_FORM_FILE_FORMAT_SET';
export const FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT = 'FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT';

export const changeFileMappingWizardCsvForm = fields => ({
  type: FILE_MAPPING_WIZARD_CSV_FORM_CHANGE,
  fields
});

export const setFileMappingWizardCsvFormFileFormat = fileFormat => ({
  type: FILE_MAPPING_WIZARD_CSV_FORM_FILE_FORMAT_SET,
  fileFormat
});

export const submitFileMappingWizardCsvForm = (file, xmlFile) => {

  let fileFormData = new FormData();
  fileFormData.append('file', file);

  let xmlFileFormData = new FormData();
  xmlFileFormData.append('file', xmlFile);

  if (xmlFile) {
    return allRequest(
      FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT,
      [REQUEST_METHOD_POST, REQUEST_METHOD_POST],
      [getUploadFileOnServerUrl(), getUploadFileOnServerUrl()],
      [fileFormData, xmlFileFormData],
      t => ({
        start: t('scenes.dataManager.fileMapping.wizard.csvForm.messages.submit.start'),
        success: t("scenes.dataManager.fileMapping.wizard.csvForm.messages.submit.success")
      }),
      null
    );
  } else {
    return postRequest(
      FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT,
      getUploadFileOnServerUrl(),
      fileFormData,
      t => ({
        start: t('scenes.dataManager.fileMapping.wizard.csvForm.messages.submit.start'),
        success: t("scenes.dataManager.fileMapping.wizard.csvForm.messages.submit.success")
      })
    );
  }
};


// WEBPACK FOOTER //
// ./src/scenes/data-manager/file-mapping/wizard/csv-form/actions.js